import BodyText from "./BodyText";
import Box from "./Box";
import GreenIcon from "./GreenIcon";
import OzoneIcon from "../assets/Icn-Ozone-Cleansed.svg";
import PrelovedIcon from "../assets/Icn-Buy-Preloved.svg";
import React from "react";
import ReturnsIcon from "../assets/Icn-30-Day.svg";
import Text from "./Text";

function TrustItem({ icon, label, text }) {
  return (
    <Box>
      <GreenIcon icon={icon} label={label} />
      <Text fontSize={[12, 12, 12, 12]} lineHeight="16px" my={15}>
        {text}
      </Text>
    </Box>
  );
}

function TrustBar() {
  return (
    <Box>
      <TrustItem
        icon={<OzoneIcon />}
        label="Ozone cleansed"
        text="All items are cleaned using our Ozone sanitisation process to make them smell as good as new."
      />
      <TrustItem
        icon={<ReturnsIcon />}
        label="30 day return"
        text="If you’re not happy with the item, just return it unworn with any tags intact for a refund."
      />
      <TrustItem
        icon={<PrelovedIcon />}
        label="Buy preloved"
        text="Make an impact!"
      />
      <Box border="1px solid" borderColor="green" px={20} py={25} mt={30}>
        <BodyText color="green">
          Choosing to buy clothing that is already out there means you're
          playing your part in creating a more sustainable world.
        </BodyText>
      </Box>
    </Box>
  );
}

export default TrustBar;
